import {mapGetters} from 'vuex'
import moment from "moment";

export default {
  methods: {
    checkKeyHasAllSameValue(arr, key, value) {
      if (arr.length === 0) {
        return false
      }
      return arr.every((obj) => {
        return obj[key] === value
      })
    },
    checkKeyHasOneSameValue(arr, key, value) {
      if (arr.length === 0) {
        return false
      }
      return arr.some((obj) => {
        return obj[key] === value
      })
    },
    checkKeyHasOneSameValueArray(arr, key, value_array = []) {
      if (arr.length === 0) {
        return false
      }
      return arr.some((obj) => {
        return value_array.includes(obj[key])
      })
    },
    checkKeyHasOneNotNullValue(arr, key) {
      if (arr.length === 0) {
        return false
      }
      return arr.some((obj) => {
        return !!obj[key]
      })
    },
    displayCarrier(items = []) {
      if (items.length === 0) {
        return 'N/A'
      }
      const finds = items.filter((x) => x.category === 'CAR')
      if (finds.length === 0) {
        return 'N/A'
      }
      const maxQuantityObj = finds.reduce((acc, curr) => parseInt(curr.quantity) > parseInt(acc.quantity) ? curr : acc
      )
      return `${maxQuantityObj.category}-${maxQuantityObj.company_product_code} (${maxQuantityObj.company_product_name})`
    },
    getDropdownData(key) {
      
      switch (key) {
        case 'customer_id':
          return this.customers
        case 'country':
          return this.countries
        case 'supplier_id':
          return this.suppliers
        case 'supplier-id':
          return this.suppliers
        case 'sundry-supplier-id':
          return this.sundry_suppliers
        case 'account_handler_id':
          return this.staffs
        case 'staff':
          return this.staffs
        case 'formulation_id':
          return this.formulations
        case 'industry_sector':
          return this.industry_sectors
        case 'customer_lead_id':
          return this.customer_leads
        case 'customer_source':
          return this.customer_sources
        case 'formulation_applications':
          return this.formulation_applications
        case 'raw-material-id':
          return this.raw_materials
        case 'vam_types':
          return this.vam_types
        case 'stage':
          return [
            {name: 'Opportunity', value: 'opportunity'},
            {name: 'Lead', value: 'lead'},
            {name: 'Subscriber', value: 'subscriber'},
            {name: 'Customer', value: 'customer'}
          ]
        case 'type':
          return [
            {name: 'Raw Material', value: 'raw_material'},
            {name: 'Sundry', value: 'sundry'},
            {name: 'Courier', value: 'courier'},
            {name: 'Other', value: 'other'},
          ]
        case 'status':
          return [
            {name: 'Open', value: 'open'},
            {name: 'Confirmed to manufacturing plan', value: 'confirmed_to_manufacturing_plan'},
            {name: 'Cancel', value: 'cancel'},
            {name: 'In Progress', value: 'in_progress'},
            {name: 'Paused', value: 'paused'},
            {name: 'Stopped', value: 'stopped'},
            {name: 'Mix Complete', value: 'mix complete'},
            {name: 'Pack Off In Progress', value: 'pack_off_in_progress'},
            {name: 'Pack Off Completed', value: 'pack_off_completed'},
          ]
        case 'interval':
          return [
            {name: 'Monthly', value: 'monthly'},
            {name: 'Weekly', value: 'weekly'},
            {name: 'Daily', value: 'daily'}
          ]
        case 'sample_order_status':
          return [
            {name: 'Requested', value: 'requested'},
            {name: 'Dispatched', value: 'dispatched'},
            {name: 'Delivered', value: 'delivered'},
            {name: 'Cancelled', value: 'cancelled'},
            {name: 'Not Approved', value: 'not_approved'},
          ]
        case 'account_currency':
          return [
            {name: 'GBP', value: 'GBP'},
            {name: 'EUR', value: 'EUR'},
            {name: 'USD', value: 'USD'},
            {name: 'AUD', value: 'AUD'},
            {name: 'DKK', value: 'DKK'},
          ]
        case 'item-status':
          return [
            {name: 'Submitted', value: 'Submitted'},
            {name: 'Accepted', value: 'Pending'},
            {name: 'In-Manufacturing', value: 'In-Manufacturing'},
            {name: 'In-QC', value: 'In-QC'},
            {name: 'In-Dispatch', value: 'In-Dispatch'},
            {name: 'Dispatched', value: 'Dispatched'},
            {name: 'Customer-Received', value: 'Customer-Received'},
            {name: 'Returned', value: 'Returned'},
            {name: 'Goods-Lost', value: 'Goods-Lost'},
          ]
        case 'credit_limit_request_status':
          return [
            {name: 'Approved', value: 'Approved'},
            {name: 'Rejected', value: 'Rejected'},
          ]
        case 'customer_status':
          return [
            {name: 'Approved', value: 'Approved'},
            {name: 'Rejected', value: 'Rejected'},
            {name: 'On Hold', value: 'On Hold'},
            {name: 'Pending Customer', value: 'Pending Customer'},
            {name: 'Lead', value: 'Lead'},
            {name: 'Pending Verification', value: 'Pending Verification'},
            {name: 'Opportunity', value: 'Opportunity'},
          ]
        case 'supplier_status':
          return [
            {name: 'SAQ Pending', value: '1'},
            {name: 'Pending Approval', value: '2'},
            {name: 'Approved', value: '3'},
            {name: 'Rejected', value: '4'},
            {name: 'On Hold', value: '5'},
          ]
        case 'sundry_supplier_status':
          return [
            {name: 'Pending', value: '1'},
            {name: 'Approved', value: '2'},
            {name: 'Rejected', value: '3'},
          ]
        case 'courier_supplier_status':
          return [
            {name: 'Pending', value: '1'},
            {name: 'Approved', value: '2'},
            {name: 'Rejected', value: '3'},
          ]
        case 'other_supplier_status':
          return [
            {name: 'Pending', value: '1'},
            {name: 'Approved', value: '2'},
            {name: 'Rejected', value: '3'},
          ]
        case 'rm-item-status':
          return [
            {name: 'Pending', value: 'Pending'},
            {name: 'Not Accepted', value: 'Not Accepted'},
            {name: 'Accepted', value: 'Accepted'},
            {name: 'Pending Dispatch', value: 'Pending Dispatch'},
            {name: 'Not Dispatched', value: 'Not Dispatched'},
            {name: 'Dispatched', value: 'Dispatched'},
            {name: 'Not Received', value: 'Not Received'},
            {name: 'Received', value: 'Received'},
            {name: 'Received - QC Passed', value: 'Received - QC Passed'},
            {name: 'Received - QC Rejected', value: 'Received - QC Rejected'},
            {name: 'Returned', value: 'Returned'},
            {name: 'Cancelled', value: 'Cancelled'},
          ]
        case 'sundry-order-item-status':
          return [
            {name: 'Pending', value: 'Pending'},
            {name: 'Not Accepted', value: 'Not Accepted'},
            {name: 'Accepted', value: 'Accepted'},
            {name: 'Pending Dispatch', value: 'Pending Dispatch'},
            {name: 'Not Dispatched', value: 'Not Dispatched'},
            {name: 'Dispatched', value: 'Dispatched'},
            {name: 'Not Received', value: 'Not Received'},
            {name: 'Received', value: 'Received'},
            {name: 'Received - QC Passed', value: 'Received - QC Passed'},
            {name: 'Received - QC Rejected', value: 'Received - QC Rejected'},
            {name: 'Returned', value: 'Returned'},
            {name: 'Cancelled', value: 'Cancelled'},
          ]
        case 'shipment_status':
          return [
            {name: 'Dispatch Booked', value: 'Dispatch Booked'},
            {name: 'Shipment Dispatched', value: 'Shipment Dispatched'},
            {name: 'Customer Received', value: 'Customer Received'},
            {name: 'Return', value: 'Return'},
            {name: 'Cancelled', value: 'Cancelled'},
          ]
        case 'other-order-status':
          return [
            {name: 'Submitted', value: 'Submitted'},
            {name: 'Accepted', value: 'Accepted'},
            {name: 'Complete', value: 'Complete'},
            {name: 'Received', value: 'Received'},
            {name: 'Returned', value: 'Returned'},
          ]
        case 'raw_material_status':
          return [
            {name: 'Pending', value: 'Pending'},
            {name: 'Approved', value: 'Approved'},
            {name: 'Rejected', value: 'Rejected'},
            {name: 'Suspended - Level 1', value: 'Suspended - Level 1'},
          ]
        case 'credit_note_status':
          return [
            {name: 'Active', value: 'Active'},
            {name: 'Invalid', value: 'Invalid'},
            {name: 'Used', value: 'Used'},
          ]
        case 'formulations_status':
          return [
            {name: 'Development', value: 'Development'},
            {name: 'Pre-Production', value: 'Pre-Production'},
            {name: 'Production', value: 'Production'},
          ]
        case 'sundry-item-status':
          return [
            {name: 'Approved', value: 'Approved'},
            {name: 'Pending', value: 'Pending'},
            {name: 'Rejected', value: 'Rejected'},
          ]
        case 'invoice-status':
          return [
            {name: 'In Draft', value: 'In Draft'},
            {name: 'Paid', value: 'Paid'},
            {name: 'Overdue', value: 'Overdue'},
            {name: 'Cancelled', value: 'Cancelled'},
          ]
        case 'po-order-types':
          return [
            {name: 'RM Order', value: 'rm-order'},
            {name: 'Sundry Order', value: 'sundry-order'},
            {name: 'Other Order', value: 'other-order'}
          ]
        case 'yes_no':
          return [
            {name: 'Yes', value: '1'},
            {name: 'No', value: '0'},
          ]
        case 'customer_account_type':
          return [
            {name: 'Proforma', value: 'proforma'},
            {name: 'Credit', value: 'credit'},
          ]
        case 'account_type':
          return [
            {name: 'Proforma', value: 'proforma'},
            {name: 'Credit', value: 'credit'},
          ]
        case 'project_brief_status':
          return [
            {name: 'Submitted', value: 'Submitted'},
            {name: 'In-Progress', value: 'In-Progress'},
            {name: 'Approved by NPD', value: 'Approved by NPD'},
            {name: 'Approved by Sales', value: 'Approved by Sales'},
            {name: 'Completed', value: 'Completed'},
          ]
        case 'rm_order_payment_status':
          return [
            {name: 'GRNI', value: 'GRNI'},
            {name: 'Pre Invoice', value: 'Pre Invoice'},
            {name: 'Paid', value: 'Paid'},
          ]
        case 'po_invoice_status':
          return [
            {name: 'GRNI', value: 'GRNI'},
            {name: 'Pre Invoice', value: 'Pre Invoice'},
            {name: 'Invoiced', value: 'Invoiced'},
            {name: 'Paid', value: 'Paid'},
          ]
        case 'sales_quote_status':
          return [
            {name: 'In-Draft', value: 'In-Draft'},
            {name: 'Live', value: 'Live'},
            {name: 'Cancelled', value: 'Cancelled'},
            {name: 'Expired', value: 'Expired'},
          ]
        case 'rm_waste_status':
          return [
            {name: 'Disposed', value: 'Disposed'},
            {name: 'Unavailable', value: 'Unavailable'},
            {name: 'Inventory Difference', value: 'Inventory Difference'},
            {name: 'QC Rejected', value: 'QC Rejected'},
            {name: 'Product Expired', value: 'Product Expired'},
            {name: 'Available', value: 'Available'},
            {name: 'Product Loss - Human error', value: 'Product Loss - Human error'},
            {name: 'Product Loss - Multiple weight out', value: 'Product Loss - Multiple weight out'},
            {name: 'Assigned to NPD', value: 'Assigned to NPD'},
            {name: 'Stock Check Adjustments', value: 'Stock Check Adjustments'},
            {name: 'Other', value: 'Other'},
          ]
        case 'product_waste_status':
          return [
            {name: 'Disposed', value: 'Disposed'},
            {name: 'Variance Amount', value: 'Variance Amount'},
            {name: 'QC Rejected', value: 'QC Rejected'}
          ]
        case 'limit':
          return [
            {name: 'Top 10', value: 10},
            {name: 'Top 20', value: 20},
            {name: 'Top 50', value: 50},
          ]
        case 'sundry_waste_status':
          return [
            {name: 'Disposed', value: 'Disposed'},
            {name: 'Inventory Difference', value: 'Inventory Difference'},
            {name: 'QC Rejected', value: 'QC Rejected'},
            {name: 'Product Loss - Human error', value: 'Product Loss - Human error'},
            {name: 'Product Loss - Multiple weight out', value: 'Product Loss - Multiple weight out'},
          ]
        case 'shipment_types':
          return [
            {name: 'All Shipments', value: null},
            {name: 'EXW Shipments', value: 1},
            {name: 'Without EXW Shipments', value: 0},
          ]
        default:
          return []
      }
    },
    rangeGenerator(options = []) {
      const today = moment()
    
      const ranges = {
        'This Month': {
          label: 'This Month',
          value: `${today.clone().startOf('month').format('DD/MM/YYYY')} to ${today.clone().endOf('month').format('DD/MM/YYYY')}`,
          key: '30'
        },
        'Previous Month': {
          label: 'Previous Month',
          value: `${today.clone().subtract(1, 'month').startOf('month').format('DD/MM/YYYY')} to ${today.clone().subtract(1, 'month').endOf('month').format('DD/MM/YYYY')}`,
          key: '60'
        },
        'This Quarter': {
          label: 'This Quarter',
          value: `${today.clone().startOf('quarter').format('DD/MM/YYYY')} to ${today.clone().endOf('quarter').format('DD/MM/YYYY')}`,
          key: '90'
        },
        'Previous Quarter': {
          label: 'Previous Quarter',
          value: `${today.clone().subtract(1, 'quarter').startOf('quarter').format('DD/MM/YYYY')} to ${today.clone().subtract(1, 'quarter').endOf('quarter').format('DD/MM/YYYY')}`,
          key: '180'
        },
        'This Year': {
          label: 'This Year',
          value: `${today.clone().startOf('year').format('DD/MM/YYYY')} to ${today.clone().endOf('year').format('DD/MM/YYYY')}`,
          key: '365'
        },
        'Previous Year': {
          label: 'Previous Year',
          value: `${today.clone().subtract(1, 'year').startOf('year').format('DD/MM/YYYY')} to ${today.clone().subtract(1, 'year').endOf('year').format('DD/MM/YYYY')}`,
          key: '600'
        },
        'Choose Your Own Dates': {
          label: 'Choose Your Own Dates',
          value: 'own_dates',
          key: 'own_dates'
        },
        'Next 7 Days': {
          label: 'Next 7 Days',
          value: `${today.clone().format('DD/MM/YYYY')} to ${today.clone().add(7, 'days').format('DD/MM/YYYY')}`,
          key: '7'
        },
        'Next 14 Days': {
          label: 'Next 14 Days',
          value: `${today.clone().format('DD/MM/YYYY')} to ${today.clone().add(14, 'days').format('DD/MM/YYYY')}`,
          key: '14'
        },
        'Next 28 Days': {
          label: 'Next 28 Days',
          value: `${today.clone().format('DD/MM/YYYY')} to ${today.clone().add(28, 'days').format('DD/MM/YYYY')}`,
          key: '28'
        },
      }
      
      return options.length > 0 
        ? options.map(opt => ranges[opt]).filter(Boolean) 
        : Object.values(ranges)
    },
    customerStatusColorFactory(id) {
      switch (id) {
        case 1:
          return 'warning';
        case 2:
          return 'warning';
        case 3:
          return 'warning';
        case 4:
          return 'warning';
        case 5:
          return 'warning';
        case 6:
          return 'primary';
        case 7:
          return 'primary';
        case 8:
          return 'danger';
        case 9:
          return 'danger';
        case 10:
          return 'danger';
          case 11:
          return 'danger';
        case 12:
          return 'warning';
      }
    },
  },
  computed: {
    ...mapGetters(['customers', 'countries', 'suppliers', 'sundry_suppliers', 'staffs', 'formulations', 'industry_sectors', 'customer_leads', 'customer_sources', 'formulation_applications', 'raw_materials', 'vam_types']),
  },
}
